import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 0C6541E7-CC47-4FF5-BEB4-F261296D7DAD
 * name send-check-outline
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/send-check-outline.svg
 * tags
 */
export const SendCheckOutlineIcon = createSvgIcon(<><path d="M2 3V10L17 12L2 14V21L23 12M4 6.03L11.53 9.25L4 8.25M11.53 14.75L4 17.97V15.75M22 15.5L18.5 19L16.5 17L15 18.5L18.5 22L23.5 17Z" /></>, 'SendCheckOutlineIcon');
export default SendCheckOutlineIcon